export default "__VITE_ASSET__Cfn$OTqa__"